import { render, staticRenderFns } from "./ManageList.vue?vue&type=template&id=e865c458&scoped=true"
import script from "./ManageList.vue?vue&type=script&lang=js"
export * from "./ManageList.vue?vue&type=script&lang=js"
import style0 from "./ManageList.vue?vue&type=style&index=0&id=e865c458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e865c458",
  null
  
)

export default component.exports